import { PipeTransform, Pipe } from '@angular/core';
import { Element } from '../entities/element.entity';

@Pipe({ name: 'filterElementEnabled' })
export class FilterElementEnabledPipe implements PipeTransform {
  transform(variants: Element[]): Element[] {
    return variants?.filter((v) => v.enabled !== false) || [];
  }
}
